import { Component, Input, OnInit } from '@angular/core';
import { Badges, BadgesService, BadgesV2Query } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-badge-achieved',
  templateUrl: './badge-achieved.component.html',
  styleUrls: ['./badge-achieved.component.scss'],
})
export class BadgeAchievedComponent implements OnInit {
  @Input() showEarnedBadgesOnly: boolean = false;
  @Input() showBannerBadges: boolean = false;
  badgesAchieved$: Observable<Badges[]>;
  numberOfCompleted$: Observable<number>;
  constructor(
    private badgeService: BadgesService,
    private badgeV2Query: BadgesV2Query
  ) {}

  ngOnInit(): void {
    firstValueFrom(this.badgeService.fetchBadgeV2(), { defaultValue: null });
    this.badgesAchieved$ = this.badgeV2Query.getAllBadgeAchieved();
    this.numberOfCompleted$ = this.badgeV2Query.getNumberOfCompletedBadge();
  }
}
